import { render, staticRenderFns } from "./Healthrecords.vue?vue&type=template&id=e650d2ee&scoped=true"
import script from "./Healthrecords.vue?vue&type=script&lang=js"
export * from "./Healthrecords.vue?vue&type=script&lang=js"
import style0 from "./Healthrecords.vue?vue&type=style&index=0&id=e650d2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e650d2ee",
  null
  
)

export default component.exports